module.exports = __webpack_public_path__ + "static/img/paypal.388ace8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paypal.png
// module id = 9JXX
// module chunks = 1